import { useDispatch } from 'react-redux';

import { useUserInput, saveUserInput } from '@store';

export const useBankTerms = () => {
	const dispatch = useDispatch();
	const { acceptedTermsAndConditionsBank: termsWereAccepted } = useUserInput();

	const acceptTerms = () => {
		dispatch(saveUserInput({ acceptedTermsAndConditionsBank: true }));
	};

	return { acceptTerms, termsWereAccepted };
};
